import { PostHogProvider } from 'posthog-js/react'

export default function CustomPostHogProvider({ children }) {
  if (
    import.meta.env.VITE_PUBLIC_POSTHOG_HOST &&
    import.meta.env.VITE_PUBLIC_POSTHOG_KEY
  ) {
    const options = {
      api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    }

    return (
      <PostHogProvider
        apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
        options={options}
      >
        {children}
      </PostHogProvider>
    )
  }

  return children
}
